<template>
  <div style="position: relative;">
    <Spin fix v-if="showLoading && loading > 0"></Spin>
    <slot :data="data" :loading="loading" :empty="!data.length"></slot>
    <error-message v-if="showEmpty && init && !data.length" :text="errorMsg" />
    <div class="flex r-center page_area" v-if="showPages && (total / limit > 1)">
      <Page :current.sync="current" :total="total" :page-size="limit" :size="'small'" @click="returnTop()" />
    </div>
  </div>
</template>

<script type="text/javascript">
  export default {
    name: 'data-list',
    data() {
      return {
        // 是否首次数据加载过了
        init: 0,
        loading: 0,
        data: [],
        current: this.page > 0 ? Number(this.page) : 1,
        total: 0
      }
    },
    props: {
      // 初始页
      page: [Number, String],
      limit: {
        type: Number,
        default: 10
      },
      url: {
        type: String,
        required: true
      },
      params: {
        type: Object,
        default () {
          return {}
        }
      },
      // 是否要加载动画
      showLoading: {
        type: Boolean,
        default: true
      },
      // 是否显示暂无数据
      showEmpty: Boolean,
      // 是否要有分页
      showPages: Boolean,
      isall: [String, Number],
      errorMsg: {
        type: String,
        default: '暂无数据'
      }
    },
    computed: {
      sendData() {
        const sendData = {
          ...this.params
        }
        if (this.showPages || this.limit) {
          sendData.page = this.current
          sendData.limit = this.limit
        }
        return sendData
      },
      trigger() {
        return this.url + '?' + this.$QueryString.stringify(this.sendData)
      }
    },
    methods: {
      refresh() {
        this.loading++
        this.$emit('on-loading', 1)
        this.$Ajax(this.url, this.sendData).then(({data,total,reviewAvatar,game_name}) => {
          this.data = data || []
          this.reviewAvatar = reviewAvatar || ''
          this.total = Number(total)
          this.$emit('on-fetch', {
            data: this.data,
            total: this.total,
            game_name
          })
        }).finally(() => {
          this.loading--
          this.$emit('on-loading', 0)
          this.init = 1
        })
      },
      //回到发帖顶部
      returnTop() {
        document.body.scrollTop = document.documentElement.scrollTop = 0
      }
    },
    watch: {
      trigger: {
        immediate: true,
        handler(v, ov) {
          if (this.init) {
            v = v ? this.$QueryString.parse(v.split('?')[1]) : {}
            ov = ov ? this.$QueryString.parse(ov.split('?')[1]) : {}
            // order 或 sort 改变的话需要回到第一页
            if (this.isall != 0) {
              this.returnTop()
            }
            if (v.order != ov.order || v.sort != ov.sort) {
              this.current = 1
            }
          }
          this.refresh()
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .page_area {
    padding: 0.8rem 0 0.6rem;
  }

  .r-center {
    justify-content: center;
  }
</style>